import { Auth0Provider } from '@auth0/auth0-react';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';
import { createRoot } from 'react-dom/client';

import App from './App';
import { GlobalStyle, styledTheme } from './ui-components';
import { GlobalThemeProvider } from './ui-components/theme/GlobalThemeProvider';

const customTheme = createTheme(styledTheme);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
    authorizationParams={{
      redirect_uri: window.location.origin + '/#/login',
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid email profile read:current_user read:users update:users',
    }}
  >
    <MUIThemeProvider theme={customTheme}>
      <GlobalThemeProvider />
      <GlobalStyle />
      <App />
    </MUIThemeProvider>
  </Auth0Provider>,
);
